// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"481":"0d78cf7e","803":"37515dd1"}[chunkId] + ".css";
};